import gql from 'graphql-tag';

import slackChannelFragment from './slackChannelFragment';

export const slackChannelsPageFragment = gql`
  fragment slackChannelsPageFragment on SlackChannelsPage {
    dokkioClass
    total
    slackChannels {
      ...slackChannelFragment
    }
  }
  ${slackChannelFragment}
`;
export default slackChannelsPageFragment;
